import React, { Component } from 'react';
import i18next from 'i18next';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import { Auth } from 'aws-amplify';
import { updateInPath, setTag } from '../../utils';

  
class NavBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeLang: props.cookies.get('lang') || 'et'
    };

    i18next.changeLanguage(this.state.activeLang);
    setTag('language', this.state.activeLang);
  }

  changeLanguage = (e, {value}) => {
    i18next.changeLanguage(value);
    this.props.cookies.set('lang', value);
    this.setState(prevState => updateInPath(prevState, 'activeLang', value));
    setTag('language', value);
  };


  handleAuthButtonClick = () => {
    if (this.props.user) {
      Auth.signOut()
        .then(this.props.history.push('/signin'))
        .catch(err => console.log(err));
    } else {
      this.props.history.push('/signin');
    }
  }

  render() {
    const u = this.props.user;
    
    // TODO: make language options come from //i18next.languages?
    return (
      this.props.authState !== 'loading' &&
        <Header
          languageOptions={[
            { flag: 'ee', text: 'Eesti keeles', value: 'et'},
            { flag: 'gb', text: 'In English', value: 'en'}
          ]}
          activeLang={this.state.activeLang}
          onChangeLanguage={this.changeLanguage}
          onAuthButtonClick={this.handleAuthButtonClick}
          groups={this.props.groups}
          username={u ? u.username : null}
        />
    );
  }
}

export default withRouter(withCookies(NavBar));



// WEBPACK FOOTER //
// ./src/common/containers/Header/index.js